import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import Team from '@views/Team';
import { DownOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';

export const TeamSelector = ({
  selected,
  teams,
  placeholder,
  teamAlign,
  onChange,
  ...props
}) => {
  let menu = (
    <Menu onClick={e => onChange(e.key)}>
      {teams.filter(code => code !== selected).map(code => (
        <Menu.Item key={code}>
          <Team code={code} align={teamAlign} />
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} {...props}>
      <a className="ant-dropdown-link">
        {selected ? <Team code={selected} align={teamAlign} /> : placeholder}{' '}
        <DownOutlined />
      </a>
    </Dropdown>
  );
};

TeamSelector.propTypes = {
  selected: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  teamAlign: PropTypes.oneOf(['left', 'right']),
  teams: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func
};

TeamSelector.defaultProps = {
  placeholder: '',
  teamAlign: 'left',
  teams: [],
  onChange: noop
};

export default TeamSelector;
